import { UrlParamTypes } from '../enums/UrlParamTypes';
const useDxpPreviewParam = () => {
    const dxpPreview = new URLSearchParams(window.location.search).get(UrlParamTypes.DXP_PREVIEW);
    return dxpPreview ? `${UrlParamTypes.DXP_PREVIEW}=${dxpPreview}` : '';
};
export default useDxpPreviewParam;
//# sourceMappingURL=useDxpPreviewParam.js.map